import { z } from 'zod';

const window = z.coerce.number().pipe(z.union([z.literal(7), z.literal(30), z.literal(90)]));

export type PreviewDays = 7 | 30 | 90;

export const PREVIEW_SHOWS = ['all', 'differed', 'pending', 'agreed'] as const;
export type PreviewShow = (typeof PREVIEW_SHOWS)[number];

/** A rule's page: the preview's window and which of its records to list; `act` opens its Decide now dialog. */
export const ruleSearchSchema = z.object({
  days: window.default(30).catch(30),
  show: z.enum(PREVIEW_SHOWS).default('all').catch('all'),
  act: z.literal('now').optional().catch(undefined),
});

export type RuleSearch = z.output<typeof ruleSearchSchema>;

const warnings = z.enum(['NoStartTime', 'DateInferred', 'NoRaces', 'IncompleteRace']);

/** A draft rule, kept in the URL so its preview survives a refresh and can be shared. */
export const newRuleSearchSchema = z.object({
  action: z
    .enum(['Publish', 'Link', 'ApplyChanges', 'DismissUnlikely', 'RejectOwnerDuplicate'])
    .default('Publish')
    .catch('Publish'),
  source: z.uuid().optional().catch(undefined),
  confidence: z.coerce.number().int().min(70).max(100).default(90).catch(90),
  allow: z
    .preprocess(
      (v) => (v === undefined ? undefined : Array.isArray(v) ? v : [v]),
      z.array(warnings),
    )
    .optional()
    .catch(undefined),
  days: window.default(30).catch(30),
  show: z.enum(PREVIEW_SHOWS).default('all').catch('all'),
});

export type NewRuleSearch = z.output<typeof newRuleSearchSchema>;
